module.exports = __webpack_public_path__ + "static/media/85.ae912010.jpg";